import React from "react";
import { AckGroup, IAckGroup } from "../ack-group";
import style from "./style.module.css";

export interface IAckOverviewProps {
    groups: IAckGroup[];
}

export function AckOverview(props: IAckOverviewProps) {
    return (
        <section className={style.ackOverview}>
            <h2 className={style.title}>Acknowledgements</h2>
            <p className={style.blurb}>This research would not be possible without the expertise and knowledge of the following people. We are grateful for their investment in us so that we could succeed.</p>
            <section className={style.groupContainer}>
                {
                    props.groups.map((group: IAckGroup) => {
                        return <AckGroup key={group.groupName} group={group} />;
                    })
                }
            </section>
        </section>
    )
}